import React from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import PageHeaderComponent from '../../helpers/components/page_header.component';
import StockReturnList from './components/stock_return_list';

const StockReturn = () => {
    return (
        <>
            <ContainerComponent span={22} top={20}>
                <PageHeaderComponent />
                <StockReturnList />
            </ContainerComponent>
        </>
    );
}

export default StockReturn;